import React from 'react';
const libraries = require('@nocode/page-templates');

// MIK-2733
const PageComponent: React.FC<{
  componentName: string | number;
}> = (props) => {
  const Component = libraries[props.componentName];

  if (!Component) {
    return <></>;
  }

  return <Component {...props} />;
};

export default PageComponent;
